import React, { useEffect, useRef, useState } from "react";

export const APP_TOAST_EVENT = "admin-toast";

export const showAppToast = ({ type = "success", message, duration = 4500 }) => {
  if (!message || typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(APP_TOAST_EVENT, { detail: { type, message, duration } }),
  );
};

const ToastNotifications = () => {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(0);

  useEffect(() => {
    const addToast = (event) => {
      const detail = event.detail || {};
      if (!detail.message) return;

      const id = nextId.current + 1;
      nextId.current = id;
      setToasts((current) => [...current, { ...detail, id }].slice(-4));

      window.setTimeout(() => {
        setToasts((current) => current.filter((toast) => toast.id !== id));
      }, detail.duration ?? 4500);
    };

    window.addEventListener(APP_TOAST_EVENT, addToast);
    return () => window.removeEventListener(APP_TOAST_EVENT, addToast);
  }, []);

  if (!toasts.length) return null;

  return (
    <div className="app-toast-stack" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => {
        const isError = toast.type === "error";
        return (
          <div key={toast.id} className={`app-toast ${isError ? "is-error" : "is-success"}`} role={isError ? "alert" : "status"}>
            <i className={`bi ${isError ? "bi-exclamation-circle-fill" : "bi-check-circle-fill"}`} aria-hidden="true" />
            <span>{toast.message}</span>
            <button type="button" onClick={() => setToasts((current) => current.filter((item) => item.id !== toast.id))} aria-label="Dismiss notification">
              <i className="bi bi-x-lg" aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ToastNotifications;
